import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/profile/cs_close_n.png'


const _hoisted_1 = { class: "name_pop" }
const _hoisted_2 = { class: "content" }

import { ref } from 'vue'
import DataField from './dataField.vue'
import { ICON_IMG } from '@/view/profile/supportScript'
import { useUserStore } from '@/stores/user'


export default /*@__PURE__*/_defineComponent({
  __name: 'withdrawalInfoPopup',
  setup(__props, { expose: __expose }) {

const userStore = useUserStore()
const show = ref(false)
const iconImages = ref(ICON_IMG)
const open = () => {
    show.value = true
}

const close = () => {
    show.value = false
}

__expose({
    open,
})


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    position: "bottom",
    style: {
        minWidth: '100%',
        minHeight: '100%',
        background: 'rgb(0, 0, 0)'
    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_van_row, { class: "title" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "22",
              style: {"display":"flex","justify-content":"center","align-items":"center"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('profile.withdrawalInfo')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, { span: "2" }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "",
                  onClick: close
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(DataField, {
            labelText: _ctx.$t('profile.name'),
            content: _unref(userStore).withdrawSetting.userName ? _unref(userStore).withdrawSetting.userName : '- -',
            leftImage: iconImages.value[0].img
          }, null, 8, ["labelText", "content", "leftImage"]),
          _createVNode(DataField, {
            labelText: _ctx.$t('profile.phoneNum'),
            content: _unref(userStore).withdrawSetting.phone ? _unref(userStore).withdrawSetting.phone : '- -',
            leftImage: iconImages.value[1].img
          }, null, 8, ["labelText", "content", "leftImage"]),
          _createVNode(DataField, {
            labelText: _ctx.$t('profile.email'),
            content: _unref(userStore).withdrawSetting.email ? _unref(userStore).withdrawSetting.email : '- -',
            leftImage: iconImages.value[2].img
          }, null, 8, ["labelText", "content", "leftImage"]),
          _createVNode(DataField, {
            labelText: _ctx.$t('profile.cpfId'),
            content: _unref(userStore).withdrawSetting.cpf ? _unref(userStore).withdrawSetting.cpf : '- -',
            leftImage: iconImages.value[3].img
          }, null, 8, ["labelText", "content", "leftImage"]),
          _createVNode(DataField, {
            labelText: _ctx.$t('profile.cnpj'),
            content: _unref(userStore).withdrawSetting.cnpj ? _unref(userStore).withdrawSetting.cnpj : '- -',
            leftImage: iconImages.value[3].img
          }, null, 8, ["labelText", "content", "leftImage"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})